// extracted by mini-css-extract-plugin
module.exports = {"button":"P8nEY___SaveSearch-module__button","filled":"_3zeCx___SaveSearch-module__filled"};